import { apiFetch } from "../useApi";

export default async function deleteCampaignIMessages(campaignId) {
  const response = await apiFetch(`/campaigns/imessages/delete`, {
    method: 'DELETE',
  });
  return response.json();
}
